import React from 'react';
import './Profile.css';

const Profile: React.FC = () => {
  const subscriptionPrice = 'AED 3.25 Per Day';
  const subscriptionDate = '2025-11-20 14:54:33';
  const renewalDate = '2025-11-21 14:54:33';

  return (
    <div className="profile-page">
      <h1 className="profile-title">MY PROFILE</h1>
      
      <div className="profile-content">
        <div className="profile-section">
          <h2 className="section-label">Recently played games</h2>
        </div>

        <div className="profile-section">
          <h2 className="section-label">Profile details</h2>
          
          <div className="profile-details">
            <div className="detail-item">
              <span className="detail-label">Subscription price</span>
              <button className="detail-value price">{subscriptionPrice}</button>
            </div>
            
            <div className="detail-item">
              <span className="detail-label">Subscription date</span>
              <button className="detail-value date">{subscriptionDate}</button>
            </div>
            
            <div className="detail-item">
              <span className="detail-label">Renewal date</span>
              <button className="detail-value date">{renewalDate}</button>
            </div>
          </div>
        </div>

        <div className="unsubscribe-section">
          <p className="unsubscribe-text">
            To Unsubscribe Send SMS - C BARD to 1111
          </p>
        </div>

        <button className="action-button">CLICK HERE</button>
      </div>
    </div>
  );
};

export default Profile;

